import { render, staticRenderFns } from "./BidOpportunityCell.vue?vue&type=template&id=0eb55c99&scoped=true"
import script from "./BidOpportunityCell.vue?vue&type=script&lang=js"
export * from "./BidOpportunityCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb55c99",
  null
  
)

export default component.exports